import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import { Colors } from '../../../../../Styles/Colors';
import Tooltip from '@mui/material/Tooltip';
import { TablePagination } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PaymentCard from '../../../../../Components/PaymentCard/PaymentCard'
import { Button, FormHelperText } from '@mui/material';
import { AmountFormat } from '../../../../../Components/CommonFunctions/CommonFunctions';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import Dialog from '../../../../../Components/Dialog';
import Failed from '../../../../../Assets/Animation/Failed.gif';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

class SalesMonthly extends Component {
    constructor(props) {
        super(props)
        var date = new Date();
        var month = date.getMonth() + 1
        var year = date.getFullYear()
        this.state = {
            Data: [],
            DataFilter: [],
            SearchFieldOpen: false,
            SearchText: "",
            page: 0,
            rowsPerPage: 5,
            AmountSortOrder: 'asc',
            AmountSortIcon: 'none',
            DateSortOrder: 'asc',
            DateSortIcon: 'none',
            MonthQuery: month,
            YearQuery: year,
            value: date,
            PharmacyID: localGetItem("Pharmacy_Id"),
            isDatePickerOpen: false
        }
    }
    componentDidMount() {
        this.getSalesMonthly()
    }

    getSalesMonthly = () => {
        try {
            let QueryParams = `?pharmacy_id=${this.state.PharmacyID}&month=${this.state.MonthQuery}&year=${this.state.YearQuery}`
            RestAPIService.getAll(Serviceurls.GET_SALES_MONTHLY + QueryParams)
                .then(response => {
                    this.setState({
                        Data: response.data.data.bill_details,
                        DataFilter: response.data.data.bill_details,
                        TotalAmt: response.data.data.total_amount
                    })
                })
                .catch(e => {
                    this.setState({ dialogBox: true, ErrorMsg: e.message });
                    setTimeout(() => {
                        this.setState({
                            dialogBox: false
                        })
                    }, 3000)
                });

        }
        catch (e) {
            this.setState({ dialogBox: true, ErrorMsg: e.message });
            setTimeout(() => {
                this.setState({
                    dialogBox: false
                })
            }, 3000)
        }
    }

    //  Mui table Pagination Functions --- starts

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: +event.target.value, page: 0 });
    }

    //  Mui table Pagination Functions --- ends

    SetDate = () => {
        this.setState({
            MonthQuery: this.state.value != null ? this.state.value.getMonth() + 1 : null,
            YearQuery: this.state.value != null ? this.state.value.getFullYear() : null
        }, () => this.getSalesMonthly())
    }

    dialogCloseFunction = () => {
        this.setState({
            dialogBox: false
        })
    }

    render() {
        const { t } = this.props;
        const DataArray = this.state.DataFilter;

        //  filter table data based on search Text
        const filtereddata = this.state.Data.filter((data) => {
            return (
                (data.invoice_date === null ? null : data.invoice_date.includes(this.state.SearchText)) ||
                (data.amount === null ? null : Math.round(data.amount * 100) === parseInt(Math.round(this.state.SearchText * 100)))
            );
        });


        // Sorting Function   ==== starts
        const sorting = (col, SortOrder) => {
            if (SortOrder === "asc") {
                const Sorted = [...this.state.Data].sort((a, b) => {
                    if (typeof (a[col]) == "string") {
                        return a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
                    } else {
                        return a[col] > b[col] ? 1 : -1
                    }
                })
                if (col === "invoice_date") {
                    this.setState({
                        DateSortOrder: 'desc',
                        DateSortIcon: 'asc',
                        AmountSortOrder: 'asc',
                        AmountSortIcon: 'none',
                    })
                }
                else if (col === "amount") {
                    this.setState({
                        DateSortOrder: 'asc',
                        DateSortIcon: 'none',
                        AmountSortOrder: 'desc',
                        AmountSortIcon: 'asc',
                    })
                }
                this.setState({
                    Data: Sorted
                })
            }
            else if (SortOrder === "desc") {
                const Sorted = [...this.state.Data].sort((a, b) => {
                    if (typeof (a[col]) == "string") {
                        return a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
                    } else {
                        return a[col] < b[col] ? 1 : -1
                    }
                })
                if (col === "invoice_date") {
                    this.setState({ DateSortOrder: 'default', DateSortIcon: "desc" })
                }
                if (col === "amount") {
                    this.setState({ AmountSortOrder: 'default', AmountSortIcon: "desc" })
                }
                this.setState({ Data: Sorted })


            }
            else if (SortOrder == "default") {
                this.setState({
                    AmountSortOrder: 'asc',
                    AmountSortIcon: 'none',
                    DateSortOrder: 'asc',
                    DateSortIcon: 'none',
                    Data: DataArray
                })
            }
        }
        // Sorting Function   ==== ends

        //  Sorting Icons Change func === starts 
        const SortIcon = (sortType) => {
            if (sortType === "asc") {
                return <Tooltip disableInteractive placement='top' title={t("InAscendingOrder")}><KeyboardArrowUpIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
            }
            else if (sortType === 'desc') {
                return <Tooltip disableInteractive placement='top' title={t("InDecendingOrder")}><KeyboardArrowDownIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
            }
            else return <Tooltip disableInteractive placement='top' title={t("Sorting")}><FilterListIcon sx={{ color: Colors.SortIconColor }} id='eMed_sorting_icon' /></Tooltip>
        }

        //  Sorting Icons Change func === ends 

        return (
            <div>
                <div className="eMed_page_header">
                    <div id='eMed_name_totalcard'>
                        <div id="eMed_table_name" style={{ color: Colors.TextColor }}>
                            {t(this.props.menuName)}
                        </div>
                        <div id="eMed_tbl_paymentcard">
                            <PaymentCard Color={Colors.orange} Icons={<AccountBalanceIcon />} Name={t("Total")} Amount={this.state.TotalAmt} />
                        </div>
                    </div>
                    <div id='eMed_tbl_filters'>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    open={this.state.isDatePickerOpen}
                                    onOpen={() => this.setState({ isDatePickerOpen: true })}
                                    onClose={() => this.setState({ isDatePickerOpen: false })}
                                    views={['year', 'month']}
                                    label={t("YearandMonth")}
                                    minDate={new Date('2012-03-01')}
                                    maxDate={new Date()}
                                    value={this.state.value}
                                    onChange={(newValue) => {
                                        this.setState({
                                            value: newValue,
                                        })
                                    }}
                                    onAccept={(values) => {
                                        this.setState({
                                            value: values
                                        }, () => {
                                            this.SetDate()
                                        })

                                    }}
                                    renderInput={(params) => <TextField
                                        sx={{ input: { color: Colors.TextColor } }} onClick={(e) => this.setState({ isDatePickerOpen: true })} id='eMed_year_filter' size='small' {...params} helperText={null} />}

                                />
                            </LocalizationProvider>
                        </div>
                        {this.state.SearchFieldOpen ?
                            <div id="eMed_tbl_searchbox" >
                                <TextField
                                    sx={{ input: { color: Colors.TextColor } }}
                                    size='small'
                                    focused
                                    onChange={(e) => this.setState({ SearchText: e.target.value })}
                                    value={this.state.SearchText}
                                    label={t("SearchHere")}
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <Tooltip disableInteractive title={t("Clear")} placement='top'><CloseIcon sx={{ color: Colors.ThemeColor }} onClick={() => { this.setState({ SearchText: '' }) }} /></Tooltip>
                                        ),
                                    }}
                                />
                            </div> : null}
                        <Tooltip disableInteractive placement="top-start" title={this.state.SearchFieldOpen ? t("CloseSearch") : t("OpenSearch")}>
                            <Button id="eMed_tbl_searchicon" variant='contained' style={{ backgroundColor: Colors.ThemeColor }} onClick={() => this.setState({ SearchFieldOpen: !this.state.SearchFieldOpen, CardOpen: false, SearchText: '' })} >
                                {this.state.SearchFieldOpen ? <CloseIcon /> : <SearchIcon />}
                            </Button>
                        </Tooltip>
                    </div>
                </div>
                <div>
                    <Card className='eMed_tbl_card' sx={{ bgcolor: Colors.TableCard }}>
                        <TableContainer className='eMed_tbl_container'>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ bgcolor: Colors.TableHeaderBarBGColor }}></TableCell>
                                        <TableCell align='center' sx={{ bgcolor: Colors.TableHeaderBarBGColor }}>
                                            <div style={{ color: Colors.TableHeaderTextColor }} className='eMed_sortable_center' id='eMed_tbl_headtext' >
                                                {t("SNo")}
                                            </div>
                                        </TableCell>
                                        <TableCell align='center' sx={{ bgcolor: Colors.TableHeaderBarBGColor }}>
                                            <div className=' eMed_sortable_center'>
                                                <div style={{ color: Colors.TableHeaderTextColor }} id='eMed_tbl_headtext'>{t("Month")}</div>
                                                <div id="eMed-SortIcons" onClick={() => { sorting("invoice_date", this.state.DateSortOrder) }}>{SortIcon(this.state.DateSortIcon)}</div>
                                            </div>
                                        </TableCell>
                                        <TableCell align='center' sx={{ bgcolor: Colors.TableHeaderBarBGColor }}>
                                            <div className=' eMed_sortable_number'>
                                                <div style={{ color: Colors.TableHeaderTextColor }} id='eMed_tbl_headtext'> {t("TotalAmount")}</div>
                                                <div id="eMed-SortIcons" onClick={() => { sorting("amount", this.state.AmountSortOrder) }}>{SortIcon(this.state.AmountSortIcon)}</div>
                                            </div>
                                        </TableCell>
                                        <TableCell sx={{ bgcolor: Colors.TableHeaderBarBGColor }}></TableCell>
                                        <TableCell sx={{ bgcolor: Colors.TableHeaderBarBGColor }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                {filtereddata.length > 0 ? filtereddata.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, index) => (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}></TableCell>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }} align='center'>
                                                <div id='eMed_tbl_bodytext'> {index + 1}</div>
                                            </TableCell>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }} align='center'>
                                                <div id='eMed_tbl_bodytext'> {data.invoice_date}</div>
                                            </TableCell>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }} align='right'>
                                                <div id='eMed_tbl_bodytext'> {AmountFormat(data.amount)}</div>
                                            </TableCell>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}></TableCell>
                                            <TableCell sx={{ bgcolor: Colors.TableBody, color: Colors.TableProfilDetails }}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                )) :
                                    <div style={{ color: Colors.TableHeaderTextColor }} id='eMed_Norecords'>
                                        {t("NoRecords")}
                                    </div>}
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component='div'
                            id="eMed_tbl_pagination"
                            sx={{
                                color: Colors.PagiantionTxtColor
                            }}
                            rowsPerPageOptions={[5, 10, 15]}
                            count={filtereddata.length}
                            rowsPerPage={this.state.rowsPerPage}
                            page={this.state.page}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                    </Card>

                    {this.state.dialogBox ?
                        <Dialog
                            type={"Notification"}
                            DialogClose={this.dialogCloseFunction}
                            header={"Message"}
                            content={this.state.ErrorMsg}
                            icon={<img className="eMed_dilboxAnimations" alt="Warning" src={Failed} />}
                            secondary={"Close"}
                            closeButton={this.dialogCloseFunction}
                        /> : null}
                </div>
            </div>
        )
    }
}
export default withTranslation()(SalesMonthly)
